import { render, staticRenderFns } from "./ProjectValuationExternalReportPage12.vue?vue&type=template&id=4b99bb3c&"
import script from "./ProjectValuationExternalReportPage12.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage12.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports